<mat-spinner class="spinner" *ngIf="isLoading"></mat-spinner>
<div class="size-selector">
  <div class="size-selector__header">
    <div class="size-selector__header__title">
      {{ 'rearLoading.sizeSelector.title' | translate }}
    </div>
  </div>

  <div>
    <frodo-size-selection [availableSizes]="spaces" (selected)="onSizeSelected($event)">
    </frodo-size-selection>
  </div>

  <div class="size-selector__button">
    <button
      class="size-selector__button__next-button"
      [ngClass]="
        !selectedSize || isLoading
          ? 'size-selector__button__next-button__disabled'
          : 'size-selector__button__next-button'
      "
      [disabled]="!selectedSize || isLoading"
      (click)="onNext()"
    >
      <p class="size-selector__button__next-button__next-button-text">
        {{ 'rearLoading.sizeSelector.next' | translate }}
      </p>
    </button>
  </div>

  <div class="size-selector__footer">
    <frodo-logo class="size-selector__footer__logo" [src]="logo"> </frodo-logo>
  </div>
</div>
